import {RouteRecordRaw} from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Auth/LoginView.vue'),
    meta: {
      title: "Home",
      requiresAuth: false
    }
  },
  {
    path: '/admin/dashboard',
    name: 'AdminIndex',
    component: () => import('../views/Admin/DashboardIndex.vue'),
    meta: {
      title: "Admin Dashboard",
      requiresAuth: true,
    }
  },
  {
    path: '/admin/record/:id?',
    name: 'ManageRecord',
    component: () => import('../views/Admin/RecordView.vue'),
    meta: {
      title: "Manage Record",
      requiresAuth: true,
    }
  },
  {
    path: '/admin/workstation/:id?/:name?',
    name: 'AdminViewWorkstation',
    component: () => import('../views/Admin/ViewWorkstationDashboard.vue'),
    meta: {
      title: "View Workstation",
      requiresAuth: true,
    }
  },
  {
    path: '/admin/workstation/manage/:user_id?/:id?',
    name: 'ManageWorkstation',
    component: () => import('../views/Admin/ManageWorkstations.vue'),
    meta: {
      title: "Manage Workstation",
      requiresAuth: true,
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: "404",
    component: () => import('../views/site/404View.vue'),
    meta: {
      title: "404 Not Found"
    }
  },
];

export default routes;
